import { Navbar } from "../components/Navbar";
import { Link } from "react-router-dom";
import { Building2, Mail, Phone, MapPin, Globe } from "lucide-react";

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      
      <div className="max-w-3xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-sm border p-8 sm:p-12">
          {/* Header */}
          <div className="text-center mb-10">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#004E64]/10 rounded-full mb-4">
              <Building2 className="w-8 h-8 text-[#004E64]" />
            </div>
            <h1 className="text-3xl font-bold text-slate-900">Impressum</h1>
            <p className="text-slate-500 mt-2">Informazioni legali obbligatorie</p>
          </div>

          {/* Content */}
          <div className="space-y-8">
            {/* Titolare */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-3 pb-2 border-b">
                Titolare del Servizio
              </h2>
              <div className="space-y-3 text-slate-700">
                <p className="font-semibold text-lg">Darko Vidakovic</p>
                <p className="text-slate-600">Titolare unico / Einzelunternehmen</p>
              </div>
            </section>

            {/* Indirizzo */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-3 pb-2 border-b">
                Sede Legale
              </h2>
              <div className="flex items-start gap-3 text-slate-700">
                <MapPin className="w-5 h-5 text-slate-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p>6945 Origlio, Ticino, Svizzera</p>
                </div>
              </div>
            </section>

            {/* Contatti */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-3 pb-2 border-b">
                Contatti
              </h2>
              <div className="space-y-3">
                <div className="flex items-center gap-3 text-slate-700">
                  <Mail className="w-5 h-5 text-slate-400" />
                  <a href="mailto:info@lavoroticino.ch" className="text-[#004E64] hover:underline">
                    info@lavoroticino.ch
                  </a>
                </div>
                <div className="flex items-center gap-3 text-slate-700">
                  <Phone className="w-5 h-5 text-slate-400" />
                  <a href="tel:+41786141854" className="text-[#004E64] hover:underline">
                    +41 78 614 18 54
                  </a>
                </div>
                <div className="flex items-center gap-3 text-slate-700">
                  <Globe className="w-5 h-5 text-slate-400" />
                  <span>www.lavoroticino.ch</span>
                </div>
              </div>
            </section>

            {/* Scopo */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-3 pb-2 border-b">
                Scopo della Piattaforma
              </h2>
              <p className="text-slate-700 leading-relaxed">
                LavoroTicino.ch è una <strong>piattaforma tecnologica</strong> per l'incontro tra 
                domanda e offerta di lavoro e servizi nel Canton Ticino e nelle zone di confine.
              </p>
              <p className="text-slate-700 leading-relaxed mt-3">
                Il servizio consiste nella messa a disposizione di una bacheca digitale di annunci
                e di un sistema di messaggistica interna per facilitare il contatto diretto tra
                le parti interessate.
              </p>
            </section>

            {/* Esclusione mediazione */}
            <section className="bg-amber-50 border border-amber-200 rounded-lg p-5">
              <h2 className="text-lg font-bold text-amber-800 mb-3">
                ⚠️ Esclusione Attività di Mediazione
              </h2>
              <p className="text-amber-900 leading-relaxed text-sm">
                LavoroTicino.ch <strong>non svolge attività di mediazione, intermediazione 
                o collocamento</strong> ai sensi della Legge federale sul Collocamento e sul 
                personale a prestito (LC, RS 823.11). Il portale opera esclusivamente come 
                piattaforma tecnologica di pubblicazione annunci. Il contatto e l'eventuale 
                rapporto contrattuale avviene direttamente tra le parti.
              </p>
            </section>

            {/* Diritto applicabile */}
            <section>
              <h2 className="text-lg font-bold text-slate-900 mb-3 pb-2 border-b">
                Diritto Applicabile e Foro Competente
              </h2>
              <p className="text-slate-700 leading-relaxed">
                Il presente sito e i suoi servizi sono soggetti al <strong>diritto svizzero</strong>. 
                Per qualsiasi controversia sarà competente in via esclusiva il 
                <strong> Foro di Lugano, Svizzera</strong>.
              </p>
            </section>
          </div>

          {/* Footer links */}
          <div className="mt-10 pt-6 border-t flex flex-wrap gap-4 text-sm">
            <Link to="/privacy" className="text-[#004E64] hover:underline">Privacy Policy</Link>
            <Link to="/terms" className="text-[#004E64] hover:underline">Termini e Condizioni</Link>
            <Link to="/" className="text-slate-500 hover:text-slate-700">← Torna alla home</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
